import React from 'react';
import { KibBreadcrumbs, KibBreadcrumbsItem } from '@chewy/kib-menus-react';
import '@chewy/kib-menus-styles/dist/styles/kib-breadcrumbs.css';
import { getPetsPath } from '../../util/config';
import { getDisplayBreadcrumb } from './utils/profile-breadcrumbs-helper';
import './profileBreadCrumbs.scss';

export const ProfileBreadCrumbs = ({ petName }: { petName: string }) => {
  const myPetsCopy = 'My Pets';

  return (
    <KibBreadcrumbs className="profile-breadcrumbs">
      <KibBreadcrumbsItem href={getPetsPath()}>{myPetsCopy}</KibBreadcrumbsItem>
      <KibBreadcrumbsItem current>{getDisplayBreadcrumb(petName)}</KibBreadcrumbsItem>
    </KibBreadcrumbs>
  );
};
